import * as styles from './TitleText.css';
import { SettingContentsList as Interface } from '../types';
import Button from '@/components/Button/Button';

const TitleText = ({
  title,
  optionText,
  buttonOptions,
}: Interface.TitleTextProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.title}>
        <p>{title}</p>
        {buttonOptions && (
          <Button
            category="secondary"
            type="outline"
            size="small"
            onClick={buttonOptions?.onClick}
          >
            {buttonOptions?.title}
          </Button>
        )}
      </div>
      <div className={styles.text}>{optionText}</div>
    </div>
  );
};

export default TitleText;
